import React from 'react';
import HeaderElement from '../components/HeaderElement';
import Footer from '../components/Footer';
import ReservationsPage from '../components/ReservationsPage';

const Reservations = () => {
  return (
    <div>
      <HeaderElement />
      <ReservationsPage />
      <Footer />
    </div>
  )
}

export default Reservations